import { cn } from '~/shared/lib/cn'
import { Step } from './step'

export function Stepper({
  className,
  steps,
  activeStepIndex,
}: {
  className?: string
  steps: Array<{
    route?: string
    label: string
    accessible?: boolean
    finished?: boolean
    flagged?: boolean
    flagSeverity?: 'high' | 'low'
    lockedReason?: string
  }>
  activeStepIndex: number
}) {
  return (
    <div className={cn('flex items-center', className)}>
      {steps.map((step, index) => (
        <div
          key={step.label}
          className="flex items-center"
        >
          {index !== 0 && <div className="bg-divider mr-2 ml-1 h-px w-[60px]" />}
          <Step
            stepNumber={index + 1}
            label={step.label}
            finished={!!step.finished}
            route={
              index !== activeStepIndex && step.accessible && !step.lockedReason
                ? step.route
                : undefined
            }
            active={index === activeStepIndex}
            skipped={!!step.finished && !step.accessible}
            flagged={step.flagged}
            flagSeverity={step.flagSeverity}
            lockedReason={step.lockedReason}
          />
        </div>
      ))}
    </div>
  )
}
